export const CTL_ADD_TO_CART = "CTL_ADD_TO_CART";
export const CTL_REMOVE_FROM_CART = "CTL_REMOVE_FROM_CART";
export const CTL_SHOW_CART = "CTL_SHOW_CART";
export const CTL_NEW_ROOM = "CTL_NEW_ROOM";
export const CTL_ROOM_TO_PROJECT = "CTL_ROOM_TO_PROJECT";
export const CTL_NEW_PROJECT = "CTL_NEW_PROJECT";
export const CTL_DOWNLOAD = "CTL_DOWNLOAD";
export const CTL_SELECTED_TO_PROJECT = "CTL_SELECTED_TO_PROJECT";
export const CTL_PROJECT_DISTRIBUTE = "CTL_PROJECT_DISTRIBUTE";
export const CTL_PROJECT_TO_ROOM = "CTL_PROJECT_TO_ROOM";
export const CTL_DUBLICATE_ROOM = "CTL_DUBLICATE_ROOM";
export const CTL_SHOW_OWN_ROOMS = "CTL_SHOW_OWN_ROOMS";
export const CTL_SEND_ROOM = "CTL_SEND_ROOM";
export const CTL_ZIP_ROOM = "CTL_ZIP_ROOM";
export const CTL_LOGIN_REGISTER = "CTL_LOGIN_REGISTER";
export const CTL_LOGIN_FORGOT = "CTL_LOGIN_FORGOT";
export const CTL_MEDIAFILE_SOURCE = "CTL_MEDIAFILE_SOURCE";
export const CTL_MEDIAFILE_EDIT = "CTL_MEDIAFILE_EDIT";

export const CTL_PLAYER_CUT = "CTL_PLAYER_CUT";
export const CTL_PLAYER_THUMB = "CTL_PLAYER_THUMB";
export const CTL_PLAYER_SKIP_BACKWARD = "CTL_PLAYER_SKIP_BACKWARD";
export const CTL_PLAYER_SKIP_FORWARD = "CTL_PLAYER_SKIP_FORWARD";
export const CTL_PLAYER_FRAME_BACKWARD = "CTL_PLAYER_FRAME_BACKWARD";
export const CTL_PLAYER_FRAME_FORWARD = "CTL_PLAYER_FRAME_FORWARD";

export const CTL_TOOLBAR_FULLTEXT_SEARCH = "CTL_TOOLBAR_FULLTEXT_SEARCH";
export const CTL_TOOLBAR_EXPERT_SEARCH = "CTL_TOOLBAR_EXPERT_SEARCH";
export const CTL_TOOLBAR_MEDIATYPE_FILTER = "CTL_TOOLBAR_MEDIATYPE_FILTER";

export const CTL_YOUTUBE_VIDEO_DELETE = "CTL_YOUTUBE_VIDEO_DELETE";
export const CTL_YOUTUBE_VIDEO_UPLOAD = "CTL_YOUTUBE_VIDEO_UPLOAD";

export const CTL_CLIPDETAIL_TOOLBAR_LANG = "CTL_CLIPDETAIL_TOOLBAR_LANG";

export const CTL_ADMIN_USER_NEW = "CTL_ADMIN_USER_NEW";

